import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import get from 'lodash/get';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import Calendar from '../shared/calendar/main';

import { selectors as rootSelectors } from '../root';

import { formatMoney } from '../../../../shared/js/format';

import { selectors, actions } from './';

import './index.less';

function Main({ intl, calendar, data, debt, ...props }) {
	const balance = get(debt, 'points.debt');

	return (
		<div className='quids-report'>
			<div className='quids-report-actions'>
				<Calendar
					intl={intl}
					{...calendar}
					onInit={calendar.calendarInit}
					onToggle={calendar.calendarToggle}
					onChange={calendar.calendarChange}
					onApply={calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.apply}
				>
					{intl('Apply')}
				</button>
				<button
					className='ui-btn ui-btn-secondary ui-icon-clear'
					onClick={props.clear}
				/>
			</div>

			<div className='quids-report-table-wrapper'>
				<table>
					<thead>
						<tr>
							<th className='sticky' />

							<th>
								<span>
									{intl('Total')}
								</span>
							</th>

							{data.months.map((month) => (
								<th key={month}>
									<span>
										{month.format('MMM YY')}
									</span>
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{renderTR(data, 'accumulated', intl('Накоплено Quids'))}
						{renderTR(data, 'avg_accumulated', intl('Ср. кол-во Quids на 1 апрув'), true, 1)}
						{renderTR(data, 'purchase_points', intl('Куплено в магазине за Quids'))}
						{renderTR(data, 'exchange_points', intl('Обмен Quids'))}
						{renderTR(data, 'exchange_amount', intl('Получено $'))}
					</tbody>
				</table>
			</div>

			{balance && (
				<div className='quids-report-balance'>
					{intl('Total balance Quids')}: <b>{formatMoney(balance.amount, true)}</b>
				</div>
			)}
		</div>
	);
}

function renderTR(data, key, title, keepDecimals, digits) {
	return (
		<tr>
			<td className='sticky'>
				<div>{title}</div>
			</td>
			<td>
				{formatMoney(data.$total[key], keepDecimals, digits)}
			</td>
			{data.list.map((item) => (
				<td key={item.month}>
					{formatMoney(item[key], keepDecimals, digits)}
				</td>
			))}
		</tr>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		// -----------------------------------------
		calendar: selectors.getCalendar(state),
		debt: rootSelectors.getDebt(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
	withPageContainer(withIntl(Main), { name: 'Quids report' })
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/quids-report/main.js